import { DebounceSettings, debounce } from 'lodash';
import { useEffect, useRef } from 'react';

export const useDebounce = (callback: Function, delay?: number, options?: DebounceSettings) => {
	const debounceOptions = { leading: false, trailing: true, ...options };
	const callbackRef = useRef(callback);
	const debounceDelay = delay ?? 500;
	const debounceRef = useRef(
		debounce((...args: any) => callbackRef.current(...args), debounceDelay, debounceOptions),
	);

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	return debounceRef.current;
};
